import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { useRouter } from "vue-router/composables";
import CiButton from "@components/base/button.vue";
import { ROUTENAMES } from "@models/constants/routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'fund-search',
  emits: ["tracking-click"],
  setup(__props, { emit }: { emit: ({ (event: "tracking-click", options: InternalTracking.TrackClickOptions): void }), expose: any, slots: any, attrs: any }) {

const router = useRouter();
const searchTerm = ref("");


const search = async () => {
  emit("tracking-click", { targetName: "FundSearch", sourceName: "Header" });
  await router.push({ name: ROUTENAMES.PRODUCTS_SEARCH_INDEX, query: { query: searchTerm.value } });
};

return { __sfc: true,router, searchTerm, emit, search, CiButton }
}

})